/**
 * Геометрия тумблера — фиксированные размеры из спеки (48×28, бегунок 22, паддинг 3).
 * Точных токенов под эти числа нет, это компонент-специфичная геометрия;
 * значения продублированы буквально в Switch.module.scss.
 */
export const SWITCH_TRACK_WIDTH = '48px'
export const SWITCH_TRACK_HEIGHT = '28px'
export const SWITCH_THUMB_SIZE = '22px'
export const SWITCH_THUMB_PADDING = '3px'

/**
 * Цвет бегунка во включённом состоянии — спека даёт буквальный #fff6e8,
 * ближайший токен ($color-text-strong — #fffdfa) недостаточно тёплый. Своего токена нет,
 * поэтому константа заводится здесь и применяется через inline style (см. Switch.tsx).
 */
export const SWITCH_THUMB_CHECKED_COLOR = '#fff6e8'
